export default __webpack_public_path__ + "static/media/logo.173e5ddb.png";